import React, { useState } from "react";
import {
  Paper,
  Grid,
  Typography,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { InputFileCustom, MasterButton, TableWrapper } from "App/Component/ui";
import { STYLE_MASTER_BARANG, urlUpload, headCellsSuccess } from ".";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
export const USER = localStorage.getItem("user_name");

export default function FormImportMasterGudang({ file, setFile, setNewData }) {
  const classes = STYLE_MASTER_BARANG();
  const SHOW_LOAD_BUTTON = {
    label: "Upload",
    color: "green",
    state: false,
    disabled: false,
  };
  const [disabled, setDisabled] = useState(SHOW_LOAD_BUTTON);
  const [countSucces, setCountSucces] = useState(0);
  const [dataSucces, setDataSucces] = useState([]);
  const [hideTable, setHideTable] = useState("none");
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: dataSucces,
    orderByDefault: "name",
    orderByRow: ["name", "id"],
  });

  const handleClickUpload = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(file)) {
        defaultToastError("Harap pilih file terlebih dahulu");
        setDisabled(SHOW_LOAD_BUTTON);
      } else {
        setHideTable("none");
        const newFormData = new FormData();
        newFormData.append("user", USER);
        newFormData.append("excelFile", file);

        const res = await instance4.post(urlUpload, newFormData);

        if (res.data.status === 200) {
          setHideTable("block");
          defaultToastSuccess(res.data.message);
          setDisabled(SHOW_LOAD_BUTTON);
          setDataSucces(res.data.data);
          setCountSucces(res.data.Jumlah_Insert);
          setNewData();
          setFile(null);
        } else {
          defaultToastError(res.data.message);
          setDisabled(SHOW_LOAD_BUTTON);
          setDataSucces([]);
          setCountSucces(0);
          setNewData();
        }
      }
    } catch (error) {
      setDisabled(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Paper className={classes.paper}>
      <p className="fw-600 mt-1">Import Barang Logistik</p>
      <Grid container spacing={2}>
        <Grid item sm={12}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <div style={{ flexGrow: 4 }}>
              <label
                htmlFor="fileBarang"
                style={{
                  fontWeight: 400,
                  color: "#BDBDBD",
                  fontSize: "11px",
                }}
              >
                Pilih File
              </label>
              <InputFileCustom
                convertToBase64={false}
                label={"Upload File"}
                name={"fileBarang"}
                id={"fileBarang"}
                initialNameFile={file}
                setFile={setFile}
              />
            </div>
            <MasterButton
              type="submit"
              name={disabled.label}
              disabled={disabled.disabled}
              color={disabled.color}
              size="lg"
              onClick={() => (disabled.disabled ? null : handleClickUpload())}
              style={{
                padding: "0.6rem 2rem",
                fontSize: "15px",
                marginTop: "25px",
                marginBottom: "25px",
              }}
            />
            <a
              href="/sample/TemplateMasterBarang.xlsx"
              type="download"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MasterButton
                type="button"
                name="Sampel"
                size="lg"
                style={{
                  padding: "0.6rem 2rem",
                  fontSize: "15px",
                  marginTop: "25px",
                  marginBottom: "25px",
                }}
              />
            </a>
          </div>
        </Grid>
      </Grid>
      <div
        style={{
          display: hideTable,
        }}
      >
        <Typography variant="p" id="countHarian" component="div">
          Total data berhasil diimport: {countSucces}
        </Typography>
        <TableWrapper
          setQ={setQ}
          withExportButton={false}
          withAddButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={dataSucces}
          headCells={headCellsSuccess}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    {index + 1}.
                  </TableCell>
                  <TableCell align="center">{row?.id}</TableCell>
                  <TableCell align="left">{row?.name}</TableCell>
                </TableRow>
              );
            })}
        </TableWrapper>
      </div>
    </Paper>
  );
}
